const routes = [
  {
    path: '/qingyang/1',
    name: 'qingyang1',
    meta: {
      title: '博士后“两站一基地”'
    },
    component: () => import('./1.vue')
  },
  {
    path: '/qingyang/2',
    name: 'qingyang2',
    meta: {
      title: '博士后留青羊区工作奖励'
    },
    component: () => import('./2.vue')
  },
  {
    path: '/qingyang/3',
    name: 'qingyang3',
    meta: {
      title: '高技能人才培训基地奖励'
    },
    component: () => import('./3.vue')
  },
  {
    path: '/qingyang/4',
    name: 'qingyang4',
    meta: {
      title: '技能大师工作室领办人奖励'
    },
    component: () => import('./4.vue')
  },
  {
    path: '/qingyang/5',
    name: 'qingyang5',
    meta: {
      title: '“青羊工匠”人才奖励'
    },
    component: () => import('./5.vue')
  },
  {
    path: '/qingyang/6',
    name: 'qingyang6',
    meta: {
      title: '市级以上“工匠”人才'
    },
    component: () => import('./6.vue')
  },
  {
    path: '/qingyang/7',
    name: 'qingyang7',
    meta: {
      title: '在站博士后生活资助'
    },
    component: () => import('./7.vue')
  }
]

export default routes